// extracted by mini-css-extract-plugin
export default {"bottomFooter":"index_bottomFooter_l-7rz"};